import { endPointPrivate } from './config'
import axios from 'axios'

export default {
  listarDashboard: () => {
    return axios.get(endPointPrivate + 'v1/dashboard')
  },
  listarComissao: () => {
    return axios.get(endPointPrivate + 'v1/comissaoMesRepresentante')
  },
  listarPedOrcamento: (param) => {
    return axios.get(endPointPrivate + 'v1/pedido?termo=' + param.termo + '&codStatus=' + param.codStatus + '&emissaoDe=' + param.emissaoDe + '&emissaoAte=' + param.emissaoAte)
  },
  obterComissaoCorrenteRepresentante: () => {
    return axios.get(endPointPrivate + 'v1/comissaoMesRepresentante')
  }
}



// WEBPACK FOOTER //
// ./src/services/dashboard.js